<template>
  <section class="auth hero is-fullheight">
    <div class="hero-body is-centered">
      <div class="container is-centered">
        <div class="sign-up-success">
          <h2 class="title has-text-white has-text-centered">
            Factura Timbrada
          </h2>
          <p class="content has-text-white has-text-centered">
            La factura se timbró correctamente.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AutoInvoiceStamped',
};
</script>

<style scoped>
  .auth {
    background: #02072e;
  }
</style>
